export default "__VITE_ASSET__Bg1KehMn__"